export class CantBeFulfilledException extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'CantBeFulfilledException'
  }
}
